import objectPath from 'object-path';

export interface StateFlaggerConfig {
    operator: "equal" | "notEqual" | "greaterThan" | "lessThan" | "test";
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    statePath: string;
    passHandler: Function;
    failHandler: Function;
}

export interface StateFlaggerMakeFlag {
    active: () => boolean | undefined;
    onPass: () => void;
    onFail: () => void;
}

const undef = void 0;
const ops = {
    equal: (stateVal, configVal): boolean => stateVal === configVal,
    notEqual: (stateVal, configVal): boolean => stateVal !== configVal,
    greaterThan: (stateVal, configVal): boolean => stateVal > configVal,
    lessThan: (stateVal, configVal): boolean => stateVal < configVal,
    test: (stateVal, configVal): boolean => configVal(stateVal),
};

export function makeFlag(store, cfg: StateFlaggerConfig = {} as unknown as StateFlaggerConfig): StateFlaggerMakeFlag {
    let okCfg: boolean = cfg && typeof cfg.statePath === 'string' && !!cfg.operator;
    const test = ops[cfg.operator];
    okCfg = okCfg && test !== undef;

    let lastResult: boolean | undefined = undef;

    const flag = {
        active: (): boolean | undefined => {
            if (!okCfg) {
                return undef;
            }

            const state = store.getState();
            if (!objectPath.has(state, cfg.statePath)) {
                return undef;
            }

            const stateValue = objectPath.get(state, cfg.statePath);
            const result = !!test(stateValue, cfg.value);
            if (lastResult !== result) {
                result ? flag.onPass() : flag.onFail();
            }
            lastResult = result;
            return result;
        },
        onPass: (): void => {
            if (typeof cfg.passHandler === 'function') {
                cfg.passHandler();
            }
        },
        onFail: (): void => {
            if (typeof cfg.failHandler === 'function') {
                cfg.failHandler();
            }
        },
    };

    return flag;
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/state-flagger/src/state-flagger.ts